import IframeTokenWrapper from "@/pages/Home/card/view/_components/SoftpointIframe/IframeTokenWrapper";

const NewCardPage = () => {
	return (
		<div className="flex flex-col max-w-container mx-auto items-center px-6  bg-white text-textDark justify-between">
			<IframeTokenWrapper />
		</div>
	);
};

export default NewCardPage;
